const STEPS = [
    {
        number: "01",
        title: "Conversa Inicial",
        description: "Entendemos o negócio, as necessidades e os objetivos do projeto.",
    },
    {
        number: "02",
        title: "Planejamento",
        description: "Definimos a estrutura, o conteúdo e a direção visual do site.",
    },
    {
        number: "03",
        title: "Desenvolvimento",
        description: "Construímos o projeto conforme o escopo e as decisões aprovadas.",
    },
    {
        number: "04",
        title: "Entrega",
        description:
            "Apresentamos o resultado final e orientamos os próximos passos para a publicação.",
    },
];

export const Process = () => {
    return (
        <section data-testid="process-section" className="py-24 border-b border-[#1e2430]">
            <div className="max-w-6xl mx-auto px-6">
                <div className="mb-16">
                    <span className="code-font text-xs text-[#2563eb] uppercase tracking-wider block mb-2">
                        05 / Metodologia
                    </span>
                    <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white">
                        Do planejamento à presença digital.
                    </h2>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {STEPS.map((step, index) => (
                        <div
                            key={step.number}
                            data-testid={`process-step-${index}`}
                            className="p-6 rounded-xl bg-[#111622] border-t-2 border-t-[#2563eb] border-x border-b border-[#1e2738]"
                        >
                            <span className="code-font text-xs text-blue-400 block mb-3">
                                {step.number}
                            </span>
                            <h3 className="text-base font-bold text-white mb-2">{step.title}</h3>
                            <p className="text-xs text-slate-400 leading-relaxed">
                                {step.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
